
// interface String {
//     isNullOrEmpty(item: string): boolean;
// }

// String.prototype.isNullOrEmpty = function(item: string): boolean {
//     return !item || 0 === item.length;
// }

export class StringExtensions {
    static isNullOrEmpty(item: string): boolean {
        return !item || 0 === item.length;
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/extensions/string-extensions.ts